import React, { useState } from 'react'
import { Card, Input, Row, Col, Checkbox } from 'antd';

const W4FormStep3 = (props) => {
  const { w4Form, setW4Form, disableAll } = props;
  const [isTotalIncome, setIsTotalIncome] = useState(false);

  const dependentsChildrenIncome = 2000;
  const dependentsOtherIncome = 500;

  const handleChange = (e) => {
    const { name, value } = e.target
    let new_value = (value ?? '') == '' ? 0 : parseInt(value);

    if (name == 'dependentsChildrenCount') {
      let dependentsChildrenAmount = new_value * parseInt(dependentsChildrenIncome);
      setW4Form({
        ...w4Form, ...{
          dependentsChildrenCount: new_value,
          dependentsChildrenAmount: (dependentsChildrenAmount ?? '').toString(),
          dependentsTotalAmount: (dependentsChildrenAmount + parseInt(w4Form.dependentsOtherAmount ?? 0) + parseInt((w4Form.taxCreditsAmount ?? 0) == '' ? 0 : w4Form.taxCreditsAmount)).toString()
        }
      })
    }
    else if (name == 'dependentsOtherCount') {
      var dependentsOtherAmount = new_value * parseInt(dependentsOtherIncome);
      setW4Form({
        ...w4Form, ...{
          dependentsOtherCount: new_value,
          dependentsOtherAmount: `${dependentsOtherAmount}`,
          dependentsTotalAmount: (parseInt(dependentsOtherAmount ?? 0) + parseInt(w4Form.dependentsChildrenAmount ?? 0) + parseInt((w4Form.taxCreditsAmount ?? 0) == '' ? 0 : w4Form.taxCreditsAmount)).toString()
        }
      })
    }
    else if (name == 'taxCreditsAmount') {
      setW4Form({
        ...w4Form, ...{
          taxCreditsAmount: new_value,
          dependentsTotalAmount: (new_value + parseInt(w4Form.dependentsChildrenAmount ?? 0) + parseInt(w4Form.dependentsOtherAmount ?? 0)).toString()
        }
      })
    }
  }

  const handleKeyUp = (e) => {
    const { keyCode } = e
    const { name } = e.target
    if (keyCode == 189) {
      if (name === 'dependentsChildrenCount') {
        setW4Form({
          ...w4Form, ...{
            dependentsChildrenCount: 0,
            dependentsChildrenAmount: 0,
            dependentsTotalAmount: 0
          }
        })
      }
      else if (name === 'dependentsOtherCount') {
        setW4Form({
          ...w4Form, ...{
            dependentsOtherCount: 0,
            dependentsOtherAmount: 0,
            dependentsTotalAmount: 0
          }
        })
      }
      else if (name === 'taxCreditsAmount') {
        setW4Form({
          ...w4Form, ...{
            taxCreditsAmount: 0,
            dependentsTotalAmount: 0
          }
        })
      }
    }
  }

  return (
    <Card type="inner" title={'Step 3. Claim Dependents'}>
      <Checkbox
        disabled={disableAll}
        checked={isTotalIncome}
        onChange={(e) => {
          setIsTotalIncome(e.target.checked);
          if (!e.target.checked) {
            setW4Form({
              ...w4Form, ...{
                dependentsChildrenCount: 0,
                dependentsChildrenAmount: null,
                dependentsOtherCount: 0,
                dependentsOtherAmount: null,
                taxCreditsAmount: null,
                dependentsTotalAmount: null
              }
            })
          }
        }}
      >
        Your total income will be $200,000 or less ($400,000 or less if married filing jointly)
      </Checkbox>  <br /> <br />
      {
        (isTotalIncome) ?
          (
            <>
              <Row>
                <Col md={7} xs={24}>Number of qualifying children under age 17</Col>
                <Col md={2} xs={7}>
                  <Input type='number' min="0"
                    disabled={disableAll}
                    name='dependentsChildrenCount'
                    value={w4Form.dependentsChildrenCount}
                    onChange={e => handleChange(e)}
                    onKeyUp={handleKeyUp}
                  />
                </Col>
                <Col md={1} xs={1} style={{ textAlign: 'center' }}>X</Col>
                <Col md={2} xs={7}> <Input prefix="$" readOnly={true} disabled={disableAll} value={dependentsChildrenIncome} /></Col>
                <Col md={1} xs={1} style={{ textAlign: 'center' }}>=</Col>
                <Col md={2} xs={7}> <Input prefix="$" readOnly={true} disabled={disableAll} value={w4Form.dependentsChildrenAmount} /></Col>
              </Row>
              <Row>
                <Col md={7} xs={24}>Number of other dependents</Col>
                <Col md={2} xs={7}>
                  <Input type='number' min="0"
                    disabled={disableAll}
                    name='dependentsOtherCount'
                    value={w4Form.dependentsOtherCount}
                    onChange={e => handleChange(e)}
                    onKeyUp={handleKeyUp}
                  /></Col>
                <Col md={1} xs={1} style={{ textAlign: 'center' }}>X</Col>
                <Col md={2} xs={7}> <Input prefix="$" readOnly={true} disabled={disableAll} value={dependentsOtherIncome} /></Col>
                <Col md={1} xs={1} style={{ textAlign: 'center' }}>=</Col>
                <Col md={2} xs={7}> <Input prefix="$" readOnly={true} disabled={disableAll} value={w4Form.dependentsOtherAmount} /></Col>
              </Row><br />
            </>
          ) : (<></>)
      }
      <p>
        You can also include other tax credits in this step, such as education tax credits and the foreign tax credit. To do so, enter the annual estimated amount of your other tax credits here.
        The other tax credits will be added to the amount of your credits for dependents and children and the combined total amount will be updated in the Step 3 Total field. Including these credits will increase your paycheck and reduce the amount of any refund you may receive when you file your tax return.
      </p>
      <Row justify='end'>
        <Col md={{ span: 3 }}>
          Other tax credits:
        </Col>
        <Col md={{ span: 2 }}>
          <Input prefix="$" style={{ width: '6em' }}
            type='number'
            min="0"
            disabled={disableAll}
            name='taxCreditsAmount'
            value={w4Form.taxCreditsAmount}
            onChange={e => handleChange(e)}
            onKeyUp={handleKeyUp}
          />
        </Col>
      </Row>
      <Row justify='end'>
        <Col md={{ span: 3 }}>
          <b>Total:</b>
        </Col>
        <Col md={{ span: 2 }}>
          <Input prefix="$" readOnly={true} disabled={disableAll} value={w4Form.dependentsTotalAmount} style={{ width: '6em' }} />
        </Col>
      </Row>
    </Card>
  )
}
export default W4FormStep3
